import { IconMinus, IconTrendingDown, IconTrendingUp } from '@tabler/icons-react';
import cx from 'clsx';

import classes from './Kpi.module.css';

export const trendIcons = {
  up: <IconTrendingUp className={cx(classes.trendIcon, classes.trendUp)} size={20} />,
  down: <IconTrendingDown className={cx(classes.trendIcon, classes.trendDown)} size={20} />,
  neutral: <IconMinus className={cx(classes.trendIcon, classes.trendNeutral)} size={20} />,
} as const;
